import { get } from 'lodash';
export const isPriceRuleValid = (membership, rule, subscriptionCreatedDate, subscriptionSwitchedDate) => {
    const untilDate = new Date(rule.options.validUntil);
    const checkDate = membership.lastIndexOf('%') !== -1
        ? untilDate.setDate(untilDate.getDate() - 1)
        : subscriptionSwitchedDate || subscriptionCreatedDate;
    if (membership && rule.options) {
        const membershipExists = rule.options.label && rule.options.label.toLowerCase().includes(stripVersion(membership).toLowerCase());
        const validFrom = !rule.options.validFrom || checkDate > new Date(rule.options.validFrom);
        const validUntil = !rule.options.validUntil || checkDate < new Date(rule.options.validUntil);
        if (validFrom && validUntil) {
            return membershipExists;
        }
    }
    return false;
};
export const isGlobalCartRule = (rule) => {
    return rule.options && rule.options.label === 'CartDiscount';
};
export const shouldApplyEmployeeDiscount = (rule, options) => {
    return (rule.options &&
        rule.options.label === 'SunsetPlusForEmployees' &&
        options.employeeDiscountToken &&
        options.employeeDiscountToken.token &&
        new Date(options.employeeDiscountToken.expiresAt) > new Date());
};
export const shouldApplySunsetPointsDiscount = (rule, options) => {
    return (rule.options &&
        rule.options.label === 'SunsetPoints' &&
        options.sunsetPoints &&
        options.sunsetPoints.totalPoints > 0);
};
export const stripVersion = function (str) {
    if (str.indexOf(' %') !== -1) {
        const adjustedStr = str.replace(' %', '%');
        return adjustedStr.lastIndexOf(' ') !== -1 ? str.substr(0, adjustedStr.lastIndexOf(' ')) : str;
    }
    return str.lastIndexOf(' ') !== -1 && str.lastIndexOf('%') !== -1 ? str.substr(0, str.lastIndexOf(' ')) : str;
};
export const getShopPattern = (shopPattern) => {
    return !shopPattern || Array.isArray(shopPattern) ? shopPattern : shopPattern.list;
};
export const getIsWhitelist = (shopPattern) => {
    return !shopPattern || Array.isArray(shopPattern) ? true : shopPattern.isWhitelist;
};
export const shouldRuleBeAppliedToShop = (shopPattern, shopId) => {
    const shopsList = getShopPattern(shopPattern);
    const isWhitelist = getIsWhitelist(shopPattern);
    if (shopPattern && typeof shopPattern === 'object' && !Array.isArray(shopPattern)) {
        if (Array.isArray(shopsList) && shopsList.length > 0) {
            return isWhitelist
                ? shopsList.find((s) => s && s.indexOf(shopId) !== -1)
                : !shopsList.find((s) => s && s.indexOf(shopId) !== -1);
        }
        return !isWhitelist;
    }
    return (!shopsList ||
        (Array.isArray(shopsList) && (shopsList.includes(shopId) || shopsList.includes('*') || shopsList.includes('*-*-*'))));
};
export const getProductSpecificDiscount = ({ price, discount }) => {
    const discountValue = parseInt(discount.discountValue);
    if (discount.discountType === 'percentDiscount') {
        return (discountValue * price) / 100;
    }
    if (discount.discountType === 'simpleDiscountFixedAmount') {
        return discountValue;
    }
    return 0;
};
export const isProductSpecificDiscount = (discount) => discount &&
    (!discount.voucherPattern || !discount.voucherPattern.length) &&
    ['simpleDiscountFixedAmount', 'percentDiscount'].includes(discount.discountType)
    ? true
    : false;
export const isFreeMealPriceRule = (rule) => get(rule, 'options.label', '').startsWith('FreeMeal:');
